export function formatSignOrderWeight(totalWeightGrams: number | null | undefined, locale: string | null | undefined): string {
  if (typeof totalWeightGrams !== 'number' || !Number.isSafeInteger(totalWeightGrams) || totalWeightGrams <= 0) return '';

  if (totalWeightGrams < 1000 || totalWeightGrams % 100 !== 0) {
    return `${totalWeightGrams} g`;
  }

  const language = locale === 'de' ? 'de-DE' : 'en-US';
  const kilograms = totalWeightGrams / 1000;
  return `${kilograms.toLocaleString(language, { maximumFractionDigits: 1 })} kg`;
}
